angular.module('impactx.MenuDirectives').controller('DeactivateSupplierBasketCtrl', [
    '$scope',
    'dataGen',
    '$context',
    'TranslationService',
    'ToastService',
    '$redirect',
    'SupplierBasketService',
    '$location',
    DeactivateSupplierBasketCtrl]);

function DeactivateSupplierBasketCtrl($scope, dataGen, $context, TranslationService, ToastService, $redirect, SupplierBasketService, $location) {
    var self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasSupplierBasket.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateSupplierBasket = TranslationService.get('deactivateSupplierBasket');
    });

    self.deactivateCurrentBasket = function() {
        var previousSupplierBasketId = $context.hasSupplierBasket.id;

        SupplierBasketService.deactivateActiveSupplierBasket().then(function(data) {
            $context.refreshBasket({}, dataGen, $context);
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(data.trns.sbtDeactivated.replace("^0", data.data.basketName));
                $redirect.redirectTo(null, "/supplierbasket/" + previousSupplierBasketId);
                $location.replace();
            });
        });
    };
}